import styled from 'styled-components';
import { CustomerClassificationValue } from '@mews-commander/legacy-data-structures';
import { TooltippedSpan } from '@mews-commander/ui';
import { customerClassificationIconNameHandler } from '@mews-commander/utils';
import { LocalizedEnumify } from '@mews/framework';
import { BareIconButton, getSpacingToken, Icon } from '@optimus-web/core';

const TooltipElement = styled(TooltippedSpan)`
    overflow: visible !important;
`;

const ClassificationElement = styled(Icon)`
    margin-left: ${getSpacingToken('100')}px;
`;

interface ClassificationIconProps {
    classification: CustomerClassificationValue;
    onClick?: () => void;
}

const ClassificationIcon: React.FC<ClassificationIconProps> = ({ onClick, classification }) => {
    const icon = customerClassificationIconNameHandler(classification.value);

    if (!icon) return null;

    return (
        <TooltipElement tooltip={<LocalizedEnumify enumValue={classification} />}>
            {onClick ? (
                <BareIconButton icon={icon.iconName} size="small" onClick={onClick} />
            ) : (
                <ClassificationElement value={icon.iconName} size="small" />
            )}
        </TooltipElement>
    );
};

export default ClassificationIcon;
